import RepositoryService from 'src/services/repository'

const resource = 'onTime/version'

export default RepositoryService.utils.createCrudRepository(resource)
